import React, { useState } from "react";

function MountainViewShowHide() {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleText = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div>
      <div className="junk-santa">
        <h3>Serving Mountain View and Surrounding Areas</h3>
        <div className="sliderline-svg">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="64"
            height="4"
            viewBox="0 0 64 4"
            fill="none"
          >
            <path
              d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
              fill="#60BDFF"
            ></path>
          </svg>
        </div>
      </div>

      <div className="junk-santa-desc">
        <p>
          We’re proud to serve Mountain View, CA, Palo Alto, Redwood City, Los
          Altos Hills, San Jose, and more! Wherever you're located within the
          Mountain View area, Junk Droid is the local service provider you can
          trust for junk hauling and professional junk removal services.
        </p>
      </div>

      {isExpanded && (
        <div>
          <div className="pt-0 junk-santa-desc">
            <h3>Call Us for a Free Quote</h3>
            <div className="sliderline-svg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="64"
                height="4"
                viewBox="0 0 64 4"
                fill="none"
              >
                <path
                  d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                  fill="#60BDFF"
                ></path>
              </svg>
            </div>
            <p className="call-junk">
              Ready to reclaim your space? Get in touch with Junk Droid for the
              best junk removal in Mountain View, CA. We provide free estimates,
              same-day service, and competitive pricing. Whether you're dealing
              with old appliances, unwanted junk, or need dumpster rental, we’ve
              got you covered.
              <br />
              Call us today at{" "}
              <a href="tel:+14085397261">
                <li>(408) 539-7261</li>
              </a>{" "}
              to schedule your junk removal service, or fill out our online form
              for a free junk removal quote.
            </p>
          </div>
        </div>
      )}

      <button className="btn btn-read" onClick={toggleText}>
        {isExpanded ? "Read Less" : "Read More"}
      </button>
    </div>
  );
}

export default MountainViewShowHide;
